
import headerBackTitle from '@/components/header/headerBackTitle'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

export default {
components: {
headerBackTitle,
Group,
XInput,
XButton,
Countdown,
Alert
},
data() {
return {
time: 60, // 计时时间
start: false, // 是否开始计时
codeStyle: '', // 获取验证码按钮颜色
timerShow: false, // 计时器显示
disabled: false, // 是否可点击 false为可点击
name: '',
icode: '',
errorDialogTitle: '友情提示', // 报错题目
errorDialogContent: '', // 报错信息
errorShow: false,
acr001:this.$route.params.acr001
}
},
methods: {
commitSuccessState() {
this.$https.post(this.BASE_URL+'uts/user/getSmsCode', {
phone: this.name,
ywNo:4
}).then((res) => {
let code = res.statusCode













this.timerShow = true
this.start = true
this.codeStyle = '#ccc!important'
this.disabled = true


}).catch((err) => {
this.errorShow = true
this.errorDialogContent = '请稍后重试'
})
},
bindBtn() {

if(this.name !== '' && this.icode !=='') {
this.$https.get(this.BASE_URL+'uts/user/bindingPhoneNew', {
params:{
phone: this.name,
icode: this.icode,
uid:this.G("zcunionid"),//"o2H4xxLfP_QvXsmsBlHbACuKcsa8"
type:4
}

})
.then((res) => {

console.log(res.statusCode)
if (res.statusCode == 200) {
this.$router.replace('/zcprojectDetail/'+this.acr001+'/'+this.G("zcuserid")+'/'+encodeURIComponent(this.G("zcnickname"))+'/null')

}else {
this.errorShow = true
this.errorDialogContent = res.message
}
}).catch((err) => {
this.errorShow = true
this.errorDialogContent = '请稍后重试'
})
}else{
this.errorShow = true
this.errorDialogContent = '输入信息不能为空'
}
},
filterFun() {
if (/[\u4E00-\u9FA5]/g.test(this.name)) {
this.name = this.name.replace(/[\u4E00-\u9FA5]/g, ' ')
}
},
countdownFinish() {
this.disabled = false, // 是否可点击 false为可点击
this.codeStyle = '', // 获取验证码按钮颜色
this.timerShow = false,
this.start = false,
this.time = 60
},
popupeVerify() {

let reg = /^(((1[3456789][0-9]{1})|(15[0-9]{1}))+\d{8})$/
let flag = reg.test(this.name)
if (this.name === '' || this.name.length < 11) {
this.errorShow = true
this.errorDialogContent = '手机号码不能为空且必须为11位'
return false
} else if (!flag) {
this.errorShow = true
this.errorDialogContent = '手机号码格式不正确'
return false
} else { // 判断用户手机号是否注册过
this.commitSuccessState()
}
}
}
}



// WEBPACK FOOTER //
// ./src/crowd_fund/bindMobile.vue